module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/flatlays/flatlay-01-1759c16e84c8f9376f1e2d78d417df17.webp";